const doc = [({"en":({"js":({"admin":({"activities":({"participants":({"index":({"participants":"Participants"})})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;